/*
 * Copyright (c) 2021. American Express Company
 */

// theirs
import * as _ from 'lodash';
import React, { Component, ReactComponentElement } from 'react';

// ours
import AccountService from '../../../services/account.service';
import CardService from '../../../services/card.service';
import NavigationService from '../../../services/navigation.service';
import OptionsBox from '../../../components/options-box/OptionsBox';
import SavingsDetails from '../../../components/savings-details/SavingsDetails';

// styles
import { ReactComponent as PigBankIcon } from 'src/bw/goal/piggy-bank.svg';

export default class SavingsGoal extends Component<any> {
    public override state = {
        showGoalDetails: false
    };

    public override render(): ReactComponentElement<any> {
        // Do not show this during onboarding or in demo mode
        const startupStep: number = _.get(this.props, 'user.attributes.startupStep');
        if (startupStep || this.props.demoMode) return null;

        const hasSavingsAccounts: boolean = AccountService.getSavingsAccounts(this.props.user).length > 0;
        const savingsGoal = CardService.hasSavingsGoal(this.props) ? CardService.getSavingsGoal(this.props) : null;

        if (savingsGoal) {
            return (
                <OptionsBox headerText="Savings Goal" icon={<PigBankIcon />}>
                    <SavingsDetails
                        originalCard={this.props.drawerProps.card}
                        card={savingsGoal}
                        user={this.props.user}
                        handleChangeCardAttribute={this.props.handleChangeCardAttribute}
                        handleUpdateCard={this.props.handleUpdateCard}
                        handleDeleteCard={this.props.handleDeleteCard}
                        toggleExpanded={() => {
                            this.setState({ showGoalDetails: !this.state.showGoalDetails });
                        }}
                        isExpanded={this.state.showGoalDetails}
                    />
                </OptionsBox>
            );
        } else if (hasSavingsAccounts) {
            return (
                <OptionsBox
                    headerText="Add a Savings Goal"
                    icon={<PigBankIcon />}
                    content={['Create a dynamic Savings Goal to track and view your progress towards your goal.']}
                    buttonText="Add Savings Goal"
                    onClick={async () => {
                        await this.props.handleCreateLinkedSavingsCard(this.props.drawerProps.card);
                        this.setState({ showGoalDetails: true });
                    }}
                />
            );
        } else {
            return (
                <OptionsBox
                    headerText="Add a Savings Goal"
                    icon={<PigBankIcon />}
                    content={['Savings goals only work with connected savings accounts.']}
                    buttonText="Connect a Savings Account"
                    onClick={async () => await this.connectAccount()}
                />
            );
        }
    }

    private async connectAccount(): Promise<void> {
        if (this.props.user.temporary) {
            this.props.handleOpenSignup(this.addAccount.bind(this, 'continue-reduce-expenses'));
        } else {
            await this.addAccount();
        }
    }

    private async addAccount(): Promise<void> {
        await NavigationService.goTo(this.props.drawerProps.history, '/drawer/add-accounts', 'Add accounts drawer');
    }
}
